import React, { useState } from 'react';
import { Send as SendIcon } from '@mui/icons-material';
import {
    InputWrapper,
    StyledTextField,
    SendButton
} from './MessageInput.styles';

const MessageInput = ({ onSendMessage, isLoading }) => {
    const [inputText, setInputText] = useState('');

    const handleSend = () => {
        const trimmedText = inputText.trim();
        if (trimmedText) {
            onSendMessage(trimmedText);
            setInputText(''); 
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault(); 
            handleSend();
        }
    };

    return (
        <InputWrapper>
            <StyledTextField
                variant="outlined"
                placeholder="Type your message here..."
                multiline
                maxRows={5} 
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyDown={handleKeyPress} 
                disabled={isLoading} 
                fullWidth
            />
            <SendButton
                aria-label="send message"
                onClick={handleSend}
                disabled={!inputText.trim() || isLoading} 
            >
                <SendIcon />
            </SendButton>
        </InputWrapper>
    );
};

export default MessageInput;